module.exports = __webpack_public_path__ + "img/qr_img.09f5b419.png";